
import { DropBox, ptz_command, PTZ_COMMAND, ptz_home, ptz_move, ptz_stop } from "@/services/hg/drone_tv/gimbal_control";
import { ChannelInfo, WEBRTC } from '@/services/hg/drone_tv/webrtc';
import store from '@/store';
import axios from "axios";
import html2canvas from 'html2canvas';
import { defineComponent } from "vue";

export default defineComponent({
  name: 'DroneTVComponent',
  props: {
    video_tag_key: {
      type: String,
      required: true
    },
    expand_width: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      dt: new WEBRTC(),
      capture_state: false,
      screen_size: 1,
      selected_channel: {} as ChannelInfo,
      channel_box_state: false,
      channel_list: [] as ChannelInfo[],
      ptz_state: false,
      description: undefined as undefined | string,
      is_show_ptz: false,
      target_index: 0,
      is_press: false,
      is_continuous: false,
      ptz_command: '',
      continuous_active_time_ms: 180,
      to: undefined as any,
      custom_id: 2,
      // captureArea: HTMLElement,
    };
  },

  mounted() {
    const video_element = document.getElementById(this.video_tag_key);
    if (video_element) {
      this.dt.SetVideoElement(video_element);
    }

    // this.onClickchannellist()
  },

  beforeDestroy() {
    this.dt.UserStop();
  },

  methods: {
    onClickRemove(info:any) {
      if(info.target._prevClass == 'v-btn__content' || info.target._prevClass == 'screen-icon') {
        return
      } else {
        this.channel_box_state = false
      }
    },
    home() {
      ptz_home(this.target_index);
    },
    ptzCommand(yaw:number, pitch:number) {
      const ptz_command_packet:PTZ_COMMAND = {
        id: store.getters.GetAccountID,
        name: this.selected_channel.psn,
        yaw: yaw,
        pitch: pitch,
      }
      ptz_command(ptz_command_packet)
    },
    async onClickCapture() {
      this.capture_state = true
      
      console.log('0')
      await setTimeout(()=> {
        console.log('1')
      }, 1000)
      console.log('2')

      const targetElement : any= this.$refs.captureArea

      if (targetElement) { 
        try {
          const canvas = await html2canvas(targetElement, {
            // scale: 4,
          });
          const imageDataUrl = canvas.toDataURL('image/png');

          const link = document.createElement('a');
          link.href = imageDataUrl;
          link.download = `${this.selected_channel.psn}_${this.convertDate()}.png`;
          document.body.appendChild(link); 
          link.click();
          document.body.removeChild(link);

          console.log('화면 캡처 성공!');
        } catch (error) {
          console.error('화면 캡처 실패:', error);
        }
      } else {
        console.warn('캡처할 요소를 찾을 수 없습니다.');
      }
      this.capture_state = false
    },
    convertDate() {
      const NewDate = new Date()

      const year = NewDate.getFullYear().toString().slice(-2)

      const month = ("0" + (NewDate.getMonth() + 1)).slice(-2); //월 2자리 (01, 02 ... 12)
      const day = ("0" + NewDate.getDate()).slice(-2); //일 2자리 (01, 02 ... 31)
      const hours = ("0" + NewDate.getHours()).slice(-2); //시 2자리 (00, 01 ... 23)
      const minutes = ("0" + NewDate.getMinutes()).slice(-2); //분 2자리 (00, 01 ... 59)
      const seconds = ("0" + NewDate.getSeconds()).slice(-2); //초 2자리 (00, 01 … 59)
      
      return `${year}년${month}월${day}일-${hours}시${minutes}분${seconds}초`
    },
    mouse_down(dir: string) {
      this.ptz_command = dir;
      this.is_press = true;
      this.to = setTimeout(() => {
        if (this.is_press) {
          this.is_continuous = true;
          console.log('continuous move', this.ptz_command, this.target_index)
          ptz_move(this.ptz_command, this.target_index, true);
        }
      }, this.continuous_active_time_ms)
    },
    mouse_up() {
      clearTimeout(this.to);
      this.is_press = false;

      if (this.is_continuous) {
        this.is_continuous = false;
        ptz_stop(this.target_index);
      }
      else {
        console.log('move', this.ptz_command, this.target_index)
        ptz_move(this.ptz_command, this.target_index);
      }
    },
    playUrl() {
      const url = prompt('Input rtsp url', 'rtsp://125.136.97.200:40000/ds-test')
      if (url) {
        this.description = url;
        this.dt.PlayFromUrl(url);
        this.is_show_ptz = false;
      }
    },
    full_screen(e: any) {
      const fullscreenTarget = document.getElementById(this.video_tag_key);
      if (fullscreenTarget) {
        if (fullscreenTarget.requestFullscreen) {
          fullscreenTarget.requestFullscreen();
        }
      }
    },
    
    onClickchannellist() {

      axios.get(`/gcs/streamlist/${store.getters.GetAccountID}`)
      .then((value) => {
        const channels:ChannelInfo[] = value.data;
        console.log(channels);

        this.channel_box_state = !this.channel_box_state
        this.channel_list = channels;
      });
      
    },
    onClickPTZset() {
      this.ptz_state = !this.ptz_state
    },
    onClickClose() {
      store.commit('SetShowDroneTV', false)
    },
    change_channel(channel: ChannelInfo) {
      if (channel) {
        this.description = `[${channel.group_index}]${channel.psn}: ${channel.description}`;
        // this.dt.PlayFromUrl('rtsp://210.99.70.120:1935/live/cctv001.stream'); //교통상황 CCTV RTSP
        this.dt.PlayFromUrl(channel.rtsp_url);
        this.is_show_ptz = true;
        this.target_index = channel.group_index;
        this.selected_channel = channel
      } else {
        this.description = undefined;
        this.dt.UserStop();
        this.is_show_ptz = false;
      }
      this.channel_box_state = false
    },
    ScreenSize(size:number) {
      this.screen_size = size
    },
    dropbox() {

      const custom_dropbox:DropBox = {
        name: this.selected_channel.psn,
        id: store.getters.GetAccountID,
        custom_id: this.custom_id == 2 ? 3 : 2,
      }
      if(this.custom_id == 2) {this.custom_id = 3}
      else if(this.custom_id == 3) {this.custom_id = 2}

      store.commit("SetModalType", 'dropbox')
      store.commit("SetModalWindow", true)

      store.commit("SetCustomDropBox", custom_dropbox)
    }
  },
});
